const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export const API_ROUTES = {
  // Routes d'analyse
  ANALYSE: `${API_BASE_URL}/analyse`,
  ANALYSE_HISTORIQUE: `${API_BASE_URL}/analyse/historique`,
  
  // Routes utilisateur
  USER_PROFILE: `${API_BASE_URL}/user/profile`,
  USER_WEIGHT: `${API_BASE_URL}/user/weight`,
  
  // Autres routes
  LOGIN: `${API_BASE_URL}/auth/login`,
  REGISTER: `${API_BASE_URL}/auth/register`
};

export const axiosConfig = {
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}; 